/** Voceras de micros y presencia en 2do Escalón para la campaña Prudence */
export const PRUDENCE_MICRO_HOSTS = 'Karla Aleska y Mariana';

export const PRUDENCE_MICRO_BRAND = 'Minuto Prudence';
